import * as React from 'react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { hideFullOptions } from 'owa-options-core';
import { ControlIcons } from 'owa-control-icons';
import { onEditorClosed } from 'owa-accounts-editor';

const styles = require('./OptionsFull.scss');

export function OptionsCloseButton({ selectedSubCategoryKey }: { selectedSubCategoryKey: string }) {
    const hide = () => {
        hideFullOptions(false, selectedSubCategoryKey);
        onEditorClosed();
    };
    return (
        <IconButton
            iconProps={{
                iconName: ControlIcons.Cancel,
            }}
            className={styles.iconButton}
            onClick={hide}
        />
    );
}
